"use strict";
exports.__esModule = true;
exports["default"] = { version: "1.0.4", date: new Date().toISOString() };
//# sourceMappingURL=build-info.js.map